/**
 * IMPORTANT: We need to keep the constants in this file and the ones in
 * the chrome extension in sync. Please mirror any changes here in the
 * constants/notifications.js file in the chrome extension repo
 */

import {
  PUSH_COMMENT_REPLIES,
  PUSH_VIDEO_COMMENTS,
  PUSH_VIDEO_PRIVACY_CHANGE,
  PUSH_VIDEO_REACTIONS,
  PUSH_VIDEO_READ,
  PUSH_VIDEO_RESHARE,
  PUSH_VIDEO_SHARE,
  PUSH_WEEKLY_DIGESTS,
} from './notificationSettings';

// Push service constants
export const PUSH_SERVER_CONTACT_EMAIL = 'mailto:team@loom.com';
export const INVALID_SUBSCRIPTION_ERROR = 'InvalidStateError';

// Client settings
export const PERMISSION_GRANTED = 'granted';
export const PERMISSION_DENIED = 'denied';
export const PERMISSION_DEFAULT = 'default'; // equivalent to denied wtf
export const PERMISSION_PROMPT = 'prompt';
export const DEVICE_UNSUPPORTED = 'device_unsupported';

// Settings
export const PUSH_ACTIVATION_SETTINGS = {
  [PUSH_VIDEO_READ]: true,
  [PUSH_VIDEO_COMMENTS]: true,
  [PUSH_COMMENT_REPLIES]: true,
  [PUSH_WEEKLY_DIGESTS]: true,
  [PUSH_VIDEO_REACTIONS]: true,
  [PUSH_VIDEO_SHARE]: true,
  [PUSH_VIDEO_RESHARE]: true,
  [PUSH_VIDEO_PRIVACY_CHANGE]: true,
};

// notification status
export const CREATED = 'created';
export const SENT = 'sent';
export const DELIVERED = 'delivered';
export const SEEN = 'seen';
export const READ = 'read';
export const NOTIF_STATUSES = [CREATED, SENT, DELIVERED, SEEN, READ];

// service worker actions
export const OPEN_URL = 'open_url';

export const NOTIFICATION_URL_PARAMS = {
  reactor: 'user_id_of_reactor',
  startAndPause: 'start_and_pause',
};

// notification types
export const COMMENT_REPLY_NOTIFICATION = 'comment_reply_notification';
export const FIRST_VIDEO_VIEW_NOTIFICATION = 'first_video_view_notification';
export const ADDED_TO_WATCH_LATER_NOTIFICATION =
  'added_to_watch_later_notification';
export const VIDEO_COMMENT_NOTIFICATION = 'video_comment_notification';
export const WEEKLY_DIGEST_NOTIFICATION = 'weekly_digest_notification';
export const VIDEO_REACTION_NOTIFICATION = 'video_reaction_notification';
export const CONTENT_LIMIT_APPROACHING_NOTIFICATION =
  'content_limit_approaching_notification';
export const CONTENT_LIMIT_REACHED_NOTIFICATION =
  'content_limit_reached_notification';
export const CREATOR_LIMIT_APPROACHING_NOTIFICATION =
  'creator_limit_approaching_notification';
export const CREATOR_LIMIT_REACHED_NOTIFICATION =
  'creator_limit_reached_notification';
export const CREATOR_LITE_LIMIT_APPROACHING_NOTIFICATION =
  'creator_lite_limit_approaching_notification';
export const CREATOR_LITE_LIMIT_REACHED_NOTIFICATION =
  'creator_lite_limit_reached_notification';
export const MEMBERSHIP_ROLE_CHANGE_NOTIFICATION =
  'membership_role_change_notification';
export const WORKSPACE_INVITATION_NOTIFICATION =
  'workspace_invitation_notification';
export const SHARE_VIDEO_NOTIFICATION = 'share_video_notification';
export const RESHARE_VIDEO_NOTIFICATION = 'reshare_video_notification';
export const VIDEO_PRIVACY_CHANGE_NOTIFICATION =
  'video_privacy_change_notification';
export const EXTERNAL_VIDEO_INGESTION_PROCESSING_NOTIFICATION =
  'external_ingestion_processing_notification';
export const EXTERNAL_VIDEO_INGESTION_COMPLETED_NOTIFICATION =
  'external_ingestion_completed_notification';

// Consolidation of all mention notification under one setting
export const COMMENT_MENTION_NOTIFICATION = 'comment_mention_notification';
export const POST_COMMENT_MENTION_NOTIFICATION =
  'post_comment_mention_notification';
export const REPLY_COMMENT_MENTION_NOTIFICATION =
  'reply_comment_mention_notification';

export const NOTIFICATION_TYPES = [
  COMMENT_REPLY_NOTIFICATION,
  CONTENT_LIMIT_APPROACHING_NOTIFICATION,
  CONTENT_LIMIT_REACHED_NOTIFICATION,
  CREATOR_LITE_LIMIT_APPROACHING_NOTIFICATION,
  CREATOR_LITE_LIMIT_REACHED_NOTIFICATION,
  FIRST_VIDEO_VIEW_NOTIFICATION,
  VIDEO_COMMENT_NOTIFICATION,
  WEEKLY_DIGEST_NOTIFICATION,
  VIDEO_REACTION_NOTIFICATION,
  MEMBERSHIP_ROLE_CHANGE_NOTIFICATION,
  ADDED_TO_WATCH_LATER_NOTIFICATION,
  WORKSPACE_INVITATION_NOTIFICATION,
  SHARE_VIDEO_NOTIFICATION,
  RESHARE_VIDEO_NOTIFICATION,
  VIDEO_PRIVACY_CHANGE_NOTIFICATION,
  POST_COMMENT_MENTION_NOTIFICATION,
  REPLY_COMMENT_MENTION_NOTIFICATION,
  EXTERNAL_VIDEO_INGESTION_PROCESSING_NOTIFICATION,
  EXTERNAL_VIDEO_INGESTION_COMPLETED_NOTIFICATION,
  EXTERNAL_VIDEO_INGESTION_PROCESSING_NOTIFICATION,
  EXTERNAL_VIDEO_INGESTION_COMPLETED_NOTIFICATION,
];

// These are notifications that users
// are able to toggle on the clients
export const TOGGLE_NOTIFICATION_TYPES = [
  FIRST_VIDEO_VIEW_NOTIFICATION,
  ADDED_TO_WATCH_LATER_NOTIFICATION,
  VIDEO_COMMENT_NOTIFICATION,
  VIDEO_REACTION_NOTIFICATION,
  COMMENT_REPLY_NOTIFICATION,
  SHARE_VIDEO_NOTIFICATION,
  RESHARE_VIDEO_NOTIFICATION,
  VIDEO_PRIVACY_CHANGE_NOTIFICATION,
  COMMENT_MENTION_NOTIFICATION,
  EXTERNAL_VIDEO_INGESTION_PROCESSING_NOTIFICATION,
  EXTERNAL_VIDEO_INGESTION_COMPLETED_NOTIFICATION,
  EXTERNAL_VIDEO_INGESTION_PROCESSING_NOTIFICATION,
  EXTERNAL_VIDEO_INGESTION_COMPLETED_NOTIFICATION,
];

// delivery medium
export const PUSH = 'push';
export const EMAIL = 'email';

// client paginations
export const DEFAULT_PAGINATION_LIMIT = 25;

// redis pubsub notification topic
export const NOTIFICATIONS_UPDATED_TOPIC = 'notifications_updated_topic';
export const RECORDING_EVENT_TOPIC = 'recording_event_topic';
export const RECORDING_COMPLETED_TOPIC = 'recording_completed_topic';
export const GIF_GENERATED_TOPIC = 'gif_generated_topic';
export const WAVEFORM_GENERATION_TOPIC = 'waveform_generation_topic';
export const SESSION_REQUEST_TOKEN_GENERATED_TOPIC =
  'session_request_token_generated_topic';

export const DELIVERY_MAIL = 'mail';
export const DELIVERY_MOBILE = 'mobile';
export const DELIVERY_WEB = 'web';
export const DELIVERY_SLACK = 'slack';
export const DELIVERY_METHODS_AVAILABLE = [
  DELIVERY_MAIL,
  DELIVERY_MOBILE,
  DELIVERY_WEB,
  DELIVERY_SLACK,
];

// paginated GQL args
export const QUERY_SHARED = 'shared';
export const QUERY_COMMENT = 'comments';
export const QUERY_REACTIONS_AND_VIEWS = 'reactions_and_views';
export const QUERY_OTHER = 'other';
export const QUERY_ALL = 'all';
